import { render } from "./SupportTickets.vue?vue&type=template&id=1b6840e2&scoped=true"
import script from "./SupportTickets.vue?vue&type=script&lang=js"
export * from "./SupportTickets.vue?vue&type=script&lang=js"

import "./SupportTickets.vue?vue&type=style&index=0&id=1b6840e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6840e2"]])

export default __exports__